import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { boolean, date, lazy, number, object, ObjectSchema, string } from 'yup';
import { isValidSocialSecurityNumber } from '../../shared';
import { originSchema } from '../../shared/validators/origin.validator';
import { ISupporteeForm } from '../models';

export const useSupporteeSchema = (): ObjectSchema<ISupporteeForm> => {
    const { t } = useTranslation();
    return useMemo(
        () =>
            object().shape({
                id: string().optional(),
                firstName: string()
                    .when('anonymous', ([anonymous], schema) => (!anonymous ? schema.required() : schema.optional()))
                    .optional(),
                lastName: string()
                    .when('anonymous', ([anonymous], schema) => (!anonymous ? schema.required() : schema.optional()))
                    .optional(),
                dateOfBirth: date().typeError(t('invalidDate')).nullable().optional(),
                nationalSecurityNumber: string()
                    .optional()
                    .test({
                        test: (value) => {
                            if (!value) return true;
                            return isValidSocialSecurityNumber(value);
                        },
                        message: t('invalidNationalSecurityNumber'),
                    }),
                gender: string().optional(),
                nationality: originSchema().nullable().optional(),
                language: originSchema().nullable().optional(),
                relation: string().nullable().optional(),
                anonymous: boolean().required(),
                dependencyPercentage: lazy((value) =>
                    value === ''
                        ? string()
                              .transform(() => 100)
                              .required()
                        : number().min(0, t('minDependencyPercentage')).max(100, t('maxDependencyPercentage')),
                ),
            }),
        [t],
    );
};
